import { css } from '@emotion/css'
import { borderRadius, breakpoint, colors, hexToRgba, mediaQueryHelper, zIndex } from '@offerzen/pinata-shame'

const styles = {
  closeButton: css({
    position: 'absolute',
    display: 'block',
    lineHeight: 1,
    top: 15,
    right: 15,
    cursor: 'pointer',
  }),

  overlay: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    padding: '40px 0',
    background: colors.modalOverlay,
    overflowY: 'auto',
    transition: '0.3s opacity',
    zIndex: zIndex.level9,
    opacity: 0,

    // IE 11 adjustments
    '@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)': {
      display: 'block',
    },
  }),

  container: css({
    width: '90%',
    margin: 'auto',
    backgroundColor: 'white',
    borderRadius: borderRadius.default,
    boxShadow: `0 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    position: 'relative',
    opacity: 0,
    transform: 'translateY(-50px) scale(0.9)',
    transition: '0.3s opacity, 0.3s transform',
  }),

  outsideClick: css({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
  }),

  // Transition classes
  overlayEntering: css({
    opacity: 0,
  }),

  overlayEntered: css({
    opacity: 1,
  }),

  modalEntered: css({
    opacity: 1,
    transform: 'translateY(0) scale(1)',
  }),

  modalExiting: css({
    opacity: 0,
    transform: 'translateY(-50px) scale(0.9)',
  }),

  overlayExiting: css({
    opacity: 0,
  }),
}

const size = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        [mediaQueryHelper(breakpoint.phone)]: {
          width: 340,
        },
      })

    case 'small':
      return css({
        [mediaQueryHelper(breakpoint.phone)]: {
          width: 400,
        },
      })

    case 'large':
      return css({
        [mediaQueryHelper(breakpoint.phone)]: {
          width: 620,
        },
      })

    case 'extraLarge': {
      return css({
        [mediaQueryHelper(breakpoint.phone)]: {
          width: 760,
        },
      })
    }

    default:
      return css({
        [mediaQueryHelper(breakpoint.phone)]: {
          width: 580,
        },
      })
  }
}

const getTransitionClass = {
  modal: {
    entering: {},
    entered: styles.modalEntered,
    exiting: styles.modalExiting,
    exited: {},
  },
  overlay: {
    entering: {},
    entered: styles.overlayEntered,
    exiting: styles.overlayExiting,
    exited: {},
  },
}

export { styles, size, getTransitionClass }
